import { AppVersionChangedModalComponent } from './shared/components/modal/app-version-changed-modal/app-version-changed-modal.component';
import { AppVersionService } from './shared/services/app-version/app-version.service';
import { TranslateService } from '@ngx-translate/core';
import { trigger } from '@angular/animations';
import { Component, OnDestroy, ChangeDetectorRef, ViewChild, inject, DestroyRef } from '@angular/core';
import { NavigationEnd, NavigationError, Router } from '@angular/router';
import { filter, startWith, Subscription } from 'rxjs';
import { FADEOUT_ANIMATION } from './shared/extensions/animations';
import { PushNotificationsService } from './shared/services/push-notifications/push-notifications.service';
import { version } from 'os';
import { MODAL_OVERLAY_CLICKED, ModalRef } from './shared/components/modal/modal-ref';
import { ModalService } from './shared/components/modal/modal.service';
import { TurnstileService } from './core/services/turnstile.service';
import { MetaTagsService } from './shared/services/meta-tags/meta-tags.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgCloudflareTurnstile, Config, State, Result, Appearance, Language, RefreshExpiry, RefreshTimeout, Retry, Size, Theme, TurnstileManager } from '@pangz/ng-cloudflare-turnstile';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [trigger('fadeOut', FADEOUT_ANIMATION)]
})
export class AppComponent implements OnDestroy {
  public title = 'Info-Car';
  routerLoaded = false;
  routerSubscription: Subscription;
  routerEventsSubscription: Subscription;
  focusOnTab = false;
  appVersion: string;
  modalRef: ModalRef | null;
  showTurnstile: boolean = false;
  destroyRef = inject(DestroyRef);
  turnstileManager: TurnstileManager;
  config: Config = {
    siteKey: environment.turnstileSiteKey,
    action: '',
    cData: '',
    tabIndex: 0,
    language: Language.AUTO,
    theme: Theme.LIGHT,
    size: Size.NORMAL,
    appearance: Appearance.INTERACTION_ONLY,
    retry: Retry.AUTO,
    retryInterval: 8000,
    refreshExpired: RefreshExpiry.AUTO,
    refreshTimeout: RefreshTimeout.AUTO,
    responseField: true,
    feedbackEnabled: true,
    onSuccess: (_: Result): void => {
      this.turnstileService.setCustomHeader(_.data);
      this.turnstileManager = _.manager;

      setTimeout(() => {
        this.showTurnstile = false;
        this.cdr.detectChanges();
      }, 1000)
    },
    onError: (_: Result): void => {
      this.turnstileService.setCustomHeader('');
      this.turnstileManager = _.manager;
    },
    onExpired: (_: Result): void => {
      _.manager.reset(_.manager['widgetId']);
    },
    onBeforeInteractive: (_: Result): void => {
      this.showTurnstile = true;
    },
    onAfterInteractive: (_: Result): void => { },
    onTimeout: (_: Result): void => { },
    onCreate: (_: Result): void => { },
    onReset: (_: Result): void => { },
    onRemove: (_: Result): void => { },
  };

  constructor(
    private router: Router, // private pushService: PushNotificationsService,
    private translate: TranslateService,
    private appVersionService: AppVersionService,
    private modal: ModalService,
    private turnstileService: TurnstileService,
    private cdr: ChangeDetectorRef,
    private metaTagsService: MetaTagsService
  ) {
    this.waitForRouterToResolveData();
    if (localStorage.getItem('lang')) {
      this.translate.use(localStorage.getItem('lang') as string);
    } else {
      localStorage.setItem('lang', 'pl');
    }
    // this.translate.use('pl');

    this.appVersionService.checkAppVersion(30000).subscribe({
      next: value => {
        if (!this.appVersion) {
          this.appVersion = value;
        }

        if (this.appVersion !== value && !this.modalRef) {
          this.modalRef = this.modal.open(AppVersionChangedModalComponent) as ModalRef;
        }

        if (this.modalRef) {
          const sub = this.modalRef.afterClosed.subscribe((value) => {
            if (!value || value === MODAL_OVERLAY_CLICKED) {
              const modalTimeout = setTimeout(() => {
                this.modalRef = null
                sub.unsubscribe();
                clearTimeout(modalTimeout);
              }, 15 * 60 * 1000)
            } else {
              sub.unsubscribe();
            }
          });
        }
      },
      error: err => {
        // Silent error
        this.appVersion === '1.0.0'
      }
    });

    this.turnstileService.resetChange().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {
        this.turnstileManager?.reset(this.turnstileManager['widgetId'])
      }
    })
  }

  private waitForRouterToResolveData() {
    this.routerSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
      ).subscribe({
        next: (x) => {
          this.routerLoaded = true;
          // if (environment.FEATURE_TOGGLES.PUSH_NOTIFICATIONS) {
          //   this.pushService.registerServiceWorker();
          // }
        },
        error: (e) => {
          console.error(e)
        },
        complete: () => {
          this.routerSubscription.unsubscribe();
        }
      });
  }

  addFocusClass() {
    this.focusOnTab = true;
  }

  removeFocusClass() {
    this.focusOnTab = false;
  }

  changeLng(lang: string) {
    this.translate.use(lang).subscribe;
    localStorage.setItem('lang', lang);
    window.location.reload();
  }
  ngOnDestroy(): void {
    this.routerEventsSubscription.unsubscribe();
  }
}
